"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkName = void 0;
const networks_1 = __importDefault(require("./networks"));
const getNetworkName = (alias) => {
    const lowerCaseAlias = alias.toLowerCase();
    for (const networkKey in networks_1.default) {
        const network = networks_1.default[networkKey];
        if (network.chain_aliases &&
            network.chain_aliases.some((networkAlias) => networkAlias.toLowerCase() === lowerCaseAlias)) {
            return networkKey;
        }
        if (networkKey.toLowerCase() === lowerCaseAlias) {
            return networkKey;
        }
    }
    return null;
};
exports.getNetworkName = getNetworkName;
